import { BenefitClassification, BenefitItem, LocalAuthority, ContactTitle, DowngradeReason, EquipmentList, FoodType, TypeOfBusiness, UnitType, WhatDoYouWantMostFromMembership, WhereDidYouHearAboutUs, ProductTier, IntentionToRenewOption, ValidationConstants, ReferenceTypes } from "../../my-account/types";
import { PaymentType } from "../memberContext/types/PaymentType";

export const defaultBenefitClassification: BenefitClassification = {
  id: '',
  text: '',
};

export const defaultBenefitItem: BenefitItem = {
  id: '',
  text: '',
};

export const defaultLocalAuthority: LocalAuthority = {
  id: '',
  text: '',
};

export const defaultContactTitle: ContactTitle = {
  id: 0,
  text: '',
};

export const defaultDowngradeReason: DowngradeReason = {
  id: '',
  text: '',
};

export const defaultEquipmentList: EquipmentList = {
  id: '',
  text: '',
};

export const defaultFoodType: FoodType = {
  id: '',
  text: '',
};

export const defaultTypeOfBusiness: TypeOfBusiness = {
  id: 0,
  text: '',
};

export const defaultUnitType: UnitType = {
  id: '',
  text: '',
};

export const defaultWhatDoYouWantMostFromMembership: WhatDoYouWantMostFromMembership = {
  id: 0,
  text: '',
};

export const defaultWhereDidYouHearAboutUs: WhereDidYouHearAboutUs = {
  id: 0,
  text: '',
};

export const defaultProductTier: ProductTier = {
  id: 0,
  text: '',
};

export const defaultPaymentType: PaymentType = {
  id: '',
  name: '',
  bankAccountRequired: false,
  isCardPayment: false,
  isContinuousPayment: null,
};

export const defaultIntentionToRenewOption: IntentionToRenewOption = {
  id: 0,
  text: '',
};

export const defaultValidationConstants: ValidationConstants = {
  nameMaxLength: 0,
  addressLineMaxLength: 0,
  townMaxLength: 0,
  countyMaxLength: 0,
  emailMaxLength: 0,
  socialMediaMaxLength: 0,
  websiteMaxLength: 0,
};

export const defaultReferenceTypes: ReferenceTypes = {
  benefitClassification: [],
  benefitItem: [],
  localAuthority: [],
  companyType: [],
  contactTitles: [],
  downgradeReasons: [],
  equipmentList: [],
  foodType: [],
  typeOfBusiness: [],
  unitType: [],
  whatDoYouWantMostFromMembership: [],
  whereDidYouHearAboutUs: [],
  productTier: [],
  paymentTypes: [],
  membershipTypes: [],
  intentionToRenewOptions: [],
  validationConstants: defaultValidationConstants,
};